import {
    RangeControl,
    __experimentalUnitControl as UnitControl,
    Flex,
    FlexItem,
} from "@wordpress/components";

const UnitRange = ({
    rangeValue,
    onRangeChange,
    unitValue = { value: 0, unit: "px" },
    onUnitChange,
    label,
    min,
    max,
    hasNoMarginBottom = true,
    style = {},
    showUnits = true,
}) => {
    return (
        <div style={style}>
            <Flex align="end" justify="space-between">
                <FlexItem
                    style={{
                        width: showUnits ? "70%" : "100%",
                        paddingRight: showUnits ? "15px" : "0",
                    }}
                >
                    <RangeControl
                        label={label}
                        value={rangeValue}
                        withInputField={false}
                        onChange={onRangeChange}
                        min={min}
                        max={max}
                        __nextHasNoMarginBottom={hasNoMarginBottom}
                    />
                </FlexItem>
                {showUnits && (
                    <FlexItem style={{ width: "30%" }}>
                        <UnitControl
                            value={
                                unitValue.value !== null
                                    ? `${unitValue.value}${unitValue.unit}`
                                    : ""
                            }
                            onChange={(newValue) => {
                                const numericValue = parseFloat(newValue);
                                const unit = newValue.replace(numericValue, "");
                                onUnitChange({
                                    value: numericValue,
                                    unit: unit,
                                });
                            }}
                            units={[
                                { value: "px", label: "px" },
                                { value: "%", label: "%" },
                                { value: "em", label: "em" },
                                { value: "rem", label: "rem" },
                                { value: "vw", label: "vw" },
                                { value: "vh", label: "vh" },
                            ]}
                        />
                    </FlexItem>
                )}
            </Flex>
        </div>
    );
};

export default UnitRange;
